/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { OutputDivisionShort } from './OutputDivisionShort';
import {
    OutputDivisionShortFromJSON,
    OutputDivisionShortFromJSONTyped,
    OutputDivisionShortToJSON,
} from './OutputDivisionShort';
import type { OutputMissionShort } from './OutputMissionShort';
import {
    OutputMissionShortFromJSON,
    OutputMissionShortFromJSONTyped,
    OutputMissionShortToJSON,
} from './OutputMissionShort';
import type { OutputPositionShort } from './OutputPositionShort';
import {
    OutputPositionShortFromJSON,
    OutputPositionShortFromJSONTyped,
    OutputPositionShortToJSON,
} from './OutputPositionShort';
import type { OutputTeamShort } from './OutputTeamShort';
import {
    OutputTeamShortFromJSON,
    OutputTeamShortFromJSONTyped,
    OutputTeamShortToJSON,
} from './OutputTeamShort';
import type { OutputUserShort } from './OutputUserShort';
import {
    OutputUserShortFromJSON,
    OutputUserShortFromJSONTyped,
    OutputUserShortToJSON,
} from './OutputUserShort';
import type { OutputZoneShort } from './OutputZoneShort';
import {
    OutputZoneShortFromJSON,
    OutputZoneShortFromJSONTyped,
    OutputZoneShortToJSON,
} from './OutputZoneShort';

/**
 * 
 * @export
 * @interface OutputAdminDetailedSession
 */
export interface OutputAdminDetailedSession {
    /**
     * 
     * @type {string}
     * @memberof OutputAdminDetailedSession
     */
    createdAt: string;
    /**
     * 
     * @type {OutputUserShort}
     * @memberof OutputAdminDetailedSession
     */
    createdBy: OutputUserShort;
    /**
     * 
     * @type {OutputDivisionShort}
     * @memberof OutputAdminDetailedSession
     */
    division: OutputDivisionShort;
    /**
     * 
     * @type {string}
     * @memberof OutputAdminDetailedSession
     */
    expiresAt: string;
    /**
     * 
     * @type {string}
     * @memberof OutputAdminDetailedSession
     */
    finishedAt: string;
    /**
     * 
     * @type {number}
     * @memberof OutputAdminDetailedSession
     */
    id: number;
    /**
     * 
     * @type {Array<OutputMissionShort>}
     * @memberof OutputAdminDetailedSession
     */
    missions: Array<OutputMissionShort>;
    /**
     * 
     * @type {OutputPositionShort}
     * @memberof OutputAdminDetailedSession
     */
    position?: OutputPositionShort;
    /**
     * 
     * @type {string}
     * @memberof OutputAdminDetailedSession
     */
    status: string;
    /**
     * 
     * @type {OutputTeamShort}
     * @memberof OutputAdminDetailedSession
     */
    team?: OutputTeamShort;
    /**
     * 
     * @type {Array<OutputUserShort>}
     * @memberof OutputAdminDetailedSession
     */
    users: Array<OutputUserShort>;
    /**
     * 
     * @type {Array<OutputZoneShort>}
     * @memberof OutputAdminDetailedSession
     */
    zones: Array<OutputZoneShort>;
}

/**
 * Check if a given object implements the OutputAdminDetailedSession interface.
 */
export function instanceOfOutputAdminDetailedSession(value: object): boolean {
    if (!('createdAt' in value)) return false;
    if (!('createdBy' in value)) return false;
    if (!('division' in value)) return false;
    if (!('expiresAt' in value)) return false;
    if (!('finishedAt' in value)) return false;
    if (!('id' in value)) return false;
    if (!('missions' in value)) return false;
    if (!('status' in value)) return false;
    if (!('users' in value)) return false;
    if (!('zones' in value)) return false;
    return true;
}

export function OutputAdminDetailedSessionFromJSON(json: any): OutputAdminDetailedSession {
    return OutputAdminDetailedSessionFromJSONTyped(json, false);
}

export function OutputAdminDetailedSessionFromJSONTyped(json: any, ignoreDiscriminator: boolean): OutputAdminDetailedSession {
    if (json == null) {
        return json;
    }
    return {
        
        'createdAt': json['createdAt'],
        'createdBy': OutputUserShortFromJSON(json['createdBy']),
        'division': OutputDivisionShortFromJSON(json['division']),
        'expiresAt': json['expiresAt'],
        'finishedAt': json['finishedAt'],
        'id': json['id'],
        'missions': ((json['missions'] as Array<any>).map(OutputMissionShortFromJSON)),
        'position': json['position'] == null ? undefined : OutputPositionShortFromJSON(json['position']),
        'status': json['status'],
        'team': json['team'] == null ? undefined : OutputTeamShortFromJSON(json['team']),
        'users': ((json['users'] as Array<any>).map(OutputUserShortFromJSON)),
        'zones': ((json['zones'] as Array<any>).map(OutputZoneShortFromJSON)),
    };
}

export function OutputAdminDetailedSessionToJSON(value?: OutputAdminDetailedSession | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'createdAt': value['createdAt'],
        'createdBy': OutputUserShortToJSON(value['createdBy']),
        'division': OutputDivisionShortToJSON(value['division']),
        'expiresAt': value['expiresAt'],
        'finishedAt': value['finishedAt'],
        'id': value['id'],
        'missions': ((value['missions'] as Array<any>).map(OutputMissionShortToJSON)),
        'position': OutputPositionShortToJSON(value['position']),
        'status': value['status'],
        'team': OutputTeamShortToJSON(value['team']),
        'users': ((value['users'] as Array<any>).map(OutputUserShortToJSON)),
        'zones': ((value['zones'] as Array<any>).map(OutputZoneShortToJSON)),
    };
}

